<template>
  <div class="Article" @click="showMore">

    <div class="stack">

      <div class="text">

        <div class="header">
          <a :href="article.rss.link" target="_blank" v-html="article.rss.title"></a>
        </div>

        <div class="source">
          {{source.name}}
        </div>
        <div class="date">
          {{date}}
        </div>
      </div>

      <img :src="article.img" v-if="article.img" onerror="this.style.display='none'" />

      <div class="text article-more" v-if="more">

        <p class="article-content" v-html="article.rss.content"></p>

        <a :href="article.rss.link" target="_blank">
          Läs hela artikeln på {{source.name}}
        </a>

      </div>
    </div>

    <div class="showMore">
      <div v-if="!more">Klicka för att visa mer</div>
      <div v-else>Klicka för att läsa artikel</div>
    </div>

  </div>
</template>

<script>

import { mapGetters } from 'vuex'
//const { mapState } = createNamespacedHelpers('namespace1/namespace2')

export default {
  name: 'Article',
  components: {
    //Component
  },
  data: function () {
    return {
      more: false
    }
  },
  props: {
    article: Object
  },
  computed: {
    /*...mapState([
      'stateField',
    ]),*/
    ...mapGetters('sources',[
      'sourceById'
    ]),
    source: function() {
      return this.sourceById(this.article.idSource)
    },
    date: function () {
      return new Date(Date.parse(this.article.rss.pubDate)).toLocaleString()
    }
  },
  methods: {
    showMore: function () {
      if(this.more){
        window.open(this.article.rss.link,'_blank')
      }
      else{
        this.more = true;
      }
    },
    onScroll: function () {
      this.showTest();
    },
    showTest: function () {
      if(this.$el.getBoundingClientRect().top - window.innerHeight < 0){
        this.$store.dispatch('articles/setDataFromOG',{article: this.article})
        this.removeScrollListener();
      }
      else{
        //console.log("Article hidden: ")
        //console.log(this.$el.getBoundingClientRect().top - window.innerHeight)
      }
    },
    addScrollListener: function () {
      this.$eventBus.$on('feed-scroll', this.onScroll);
      this.showTest();
    },
    removeScrollListener: function () {
      this.$eventBus.$off('feed-scroll', this.onScroll);
    }
  },
  mounted: function () {
    this.article.setImage();
    if(!this.article.img){
      this.addScrollListener();
    }
  },
  created: function () {

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.Article{
  position: relative;
  display: flex;
  background: white;
  max-height: 400px;
  overflow-y: hidden;
  cursor: pointer;
}

.stack{
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

img{
  width: 100%;
}

.text{
  padding: 5px 10px 10px 10px;
}

.header{
  margin-bottom: 5px;
  font-family: var(--font-header);
  font-size: large;
}

.article-content{
  overflow: hidden;
}

.article-more{
  margin-bottom: 1em;
}

.source, .date{
  font-size: smaller;
  text-transform: uppercase;
}

.date{
  color: gray;
}

.showMore{
  //display: none;
  visibility: hidden;
  position: absolute;
  bottom: 0px;
  text-align: center;
  width: 100%;
  opacity: 90%;
}

.Article:hover > .showMore {
  visibility: visible;
  //display: inline !important;
}

.showMore > div {
  background: var(--color);
  color: white;
  padding: 2px 4px 2px 4px;
}

</style>

<style lang="scss">
  .article-content img, .article-content iframe{
    width: 100%;
    height: auto;
    margin: 0;
  }
</style>
